const mutations = {
  LOAD_LIST_EVENT_MANAGERS(state, list) {
    state.listaEventManagers = list;
  },
  PREPARE_TO_EDIT_EVENT_MANAGER(state, data) {
    state.eventManager = { ...data };
  },
  RESET_EVENT_MANAGER(state) {
    state.eventManager = {
      id: null,
      evento: { id: null },
      responsavel: { id: null },
      ativo: true,
    };
  },
};

export default mutations;
